import React from "react";
import { Modal, Form, Input, Button } from "antd";
import { LockOutlined } from "@ant-design/icons";
import "./ChangePasswordModal.css";

const { Item } = Form;

const ChangePasswordModal = ({ open, onCancel, onFinish, form }) => {
  const handleCancel = () => {
    form?.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={
        <span className="cp-modal-title">
          <LockOutlined className="cp-modal-title-icon" />
          Change Password
        </span>
      }
      open={open}
      onCancel={handleCancel}
      footer={null}
      className="cp-modal"
      width={420}
      centered
      destroyOnClose
    >
      <Form
        form={form}
        name="changePasswordForm"
        onFinish={onFinish}
        layout="vertical"
        className="cp-form"
        requiredMark={false}
      >
        <Item
          name="currentPassword"
          label="Current Password"
          rules={[{ required: true, message: "Please enter your current password" }]}
        >
          <Input.Password placeholder="Enter current password" size="large" />
        </Item>
        <Item
          name="newPassword"
          label="New Password"
          rules={[{ required: true, message: "Please enter your new password" }]}
        >
          <Input.Password placeholder="Enter new password" size="large" />
        </Item>
        <Item
          name="confirmNewPassword"
          label="Confirm New Password"
          dependencies={["newPassword"]}
          rules={[
            { required: true, message: "Please confirm your new password" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) return Promise.resolve();
                return Promise.reject(new Error("Passwords do not match"));
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm new password" size="large" />
        </Item>
        <Item className="cp-form-actions" noStyle>
          <div className="cp-form-actions-inner">
            <Button size="large" onClick={handleCancel} className="cp-btn-cancel">
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" size="large" className="cp-btn-submit">
              Update Password
            </Button>
          </div>
        </Item>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
